import React from 'react';
import { Card, CardBody, CardTitle, CardText, Col, Row, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const Cards = () => {

  const navigate = useNavigate();

  const demoCards = [
    {
      id: 1,
      title: "Document Scanner",
      description: "AI-powered document scanner with intelligent OCR technology that automatically extracts text, recognizes document layouts, and converts scanned images into searchable, editable digital documents with high accuracy.",
      icon: "ri-file-pdf-2-line",
      color: "#6259ca",
      tag: "OCR · AI",
      link: "/document-scanner",
    },
    {
      id: 2,
      title: "Invoice Scanner",
      description: "Advanced AI invoice processing system that automatically detects and extracts key data fields including vendor names, amounts, dates, and line items with machine learning algorithms for accurate data capture and validation.",
      icon: "ri-bill-line",
      color: "#02c0f8",
      tag: "Finance · ML",
      link: "/invoice-scanner",
    },
    {
      id: 3,
      title: "Call Analyzer",
      description: "AI-driven call analysis tool that transcribes audio recordings, identifies key discussion points, extracts action items, analyzes participant sentiment, and generates comprehensive summaries for better insights.",
      icon: "ri-phone-line",
      color: "#f5a623",
      tag: "Voice · NLP",
      link: "/call-analyzer",
    },
    {
      id: 4,
      title: "Warehouse Bot",
      description: "Intelligent warehouse chatbot that leverages natural language processing to answer inventory queries, track stock levels, process orders, and provide real-time insights from your warehouse data.",
      icon: "ri-message-2-line",
      color: "#50cd89",
      tag: "Chatbot · NLP",
      link: "/chat",
    },
    {
      id: 5,
      title: "Maintenance Bot",
      description: "AI-powered maintenance assistant that helps teams log issues, retrieve equipment history, schedule preventive maintenance tasks, and get instant answers from technical manuals and service records.",
      icon: "ri-robot-line",
      color: "#f1416c",
      tag: "Chatbot · AI",
      link: "/chatbot",
    },
    {
      id: 6,
      title: "Analysis & Prediction",
      description: "ML-driven inventory analysis dashboard that forecasts demand, identifies critical stock-out risks, tracks reorder levels, and delivers AI-powered recommendations to keep your supply chain healthy.",
      icon: "ri-line-chart-line",
      color: "#7239ea",
      tag: "ML · Forecast",
      link: "/analysis-prediction",
    },
  ];

  document.title = "Whistlemind Demo Engine | Dashboard";

  return (
    <React.Fragment>
      <div>
        <Row>
          {demoCards.map((card) => (
            <Col xl={4} lg={4} md={6} key={card.id} className="mb-4">
              <Card
                className="h-100 border-0"
                style={{
                  borderRadius: 12,
                  boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                  transition: 'transform 0.18s ease, box-shadow 0.18s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.07)';
                }}
                onClick={() => navigate(card.link)}
              >
                {/* Coloured top accent bar */}
                <div style={{ height: 4, background: card.color, borderRadius: '12px 12px 0 0' }} />

                <CardBody className="d-flex flex-column p-4">
                  {/* Icon + tag row */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-3"
                      style={{ width: 48, height: 48, background: `${card.color}18`, flexShrink: 0 }}
                    >
                      <i className={`${card.icon} fs-4`} style={{ color: card.color }} />
                    </div>
                    <span
                      className="badge rounded-pill"
                      style={{
                        background: `${card.color}15`,
                        color: card.color,
                        border: `1px solid ${card.color}30`,
                        fontSize: 11,
                        fontWeight: 600,
                        padding: '4px 10px',
                      }}
                    >
                      {card.tag}
                    </span>
                  </div>

                  <CardTitle tag="h5" className="mb-2 fw-semibold" style={{ color: '#2d3748' }}>
                    {card.title}
                  </CardTitle>

                  <CardText className="text-muted flex-grow-1" style={{ fontSize: 13, lineHeight: 1.65 }}>
                    {card.description}
                  </CardText>

                  <Button
                    size="sm"
                    className="mt-3 w-100 fw-semibold"
                    style={{
                      background: card.color,
                      border: 'none',
                      borderRadius: 8,
                      padding: '8px 0',
                      letterSpacing: '0.02em',
                    }}
                    onClick={(e) => { e.stopPropagation(); navigate(card.link); }}
                  >
                    <i className="ri-arrow-right-line me-1" />
                    Open
                  </Button>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Cards;
